import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { Problems } from './components/Problems';
import { Audience } from './components/Audience';
import { Overview } from './components/Overview';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Comparison } from './components/Comparison';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { EliteUpsell } from './components/EliteUpsell';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
const META_PIXEL_ID = '1262632319352268';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function App() {
  useEffect(() => {
    // Official Meta Pixel base code (https://developers.facebook.com/docs/meta-pixel/get-started)
    // Loaded once when the landing mounts; fires a PageView event.
    if (typeof window === 'undefined') return;
    if (window.fbq) {
      // Already initialized — just fire PageView
      window.fbq('track', 'PageView');
      return;
    }
    ;
    (function (f: any, b: Document, e: string, v: string) {
      let n: any;
      if (f.fbq) return;
      n = f.fbq = function () {
        // eslint-disable-next-line prefer-rest-params
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode?.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-rugby-green-900 font-sans text-slate-100" data-id="element-0">
      {/* <noscript> fallback pixel for users with JS disabled */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" />
      </noscript>

      <Hero data-id="element-3" />
      <Testimonials data-id="element-4" />
      <Problems data-id="element-5" />
      <Audience data-id="element-6" />
      <Overview data-id="element-7" />
      <Tomos data-id="element-8" />
      <Bonos data-id="element-9" />
      <Comparison data-id="element-10" />
      <Urgency data-id="element-11" />
      <Pricing data-id="element-12" />
      <EliteUpsell data-id="element-13" />
      <Guarantee data-id="element-14" />
      <FAQ data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
      <PurchasePopup data-id="element-18" />
    </div>;
}